import React from 'react'
import PropTypes from 'prop-types'
import { useLabels } from '../../../utils/hooks/useLabels/useLabels'
import IndividualDiscount from './Forms/Discount/IndividualDiscount'
import Dni from './Forms/Dni'
import Individual from './Forms/Individual'
import Massive from './Forms/Massive'
import MassiveDiscount from './Forms/Discount/MassiveDiscount'

export const formTypes = {
  individual: 'individual',
  direct_by_dni: 'dni',
  massive: 'massive',
}
export const formContexts = {
  new_refill: 'new_refill',
  discount: 'discount',
}
const formsTypesComponents = {
  new_refill: {
    individual: Individual,
    dni: Dni,
    massive: Massive,
  },
  discount: {
    individual: IndividualDiscount,
    massive: MassiveDiscount,
  },
}

function FormFactory({ type, context }) {
  const FormComponent = formsTypesComponents[context][type]
  const { texts } = useLabels()
  let warningText = ''
  if (type === formTypes.massive) {
    if (context === formContexts.new_refill) {
      warningText = texts.massive_advertise
    } else {
      warningText = texts.massive_advertise_discount
    }
  }
  if (FormComponent) return <FormComponent warningText={warningText} />
  return null
}

FormFactory.propTypes = {
  context: PropTypes.string,
  type: PropTypes.string,
}

export default FormFactory
